export var isExternalURI = function (to) {
    return /http|tel:|mailto:/.test(to);
};
//# sourceMappingURL=isExternalURI.js.map